import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "800",
  height: "800",
  viewBox: "0 0 8 8",
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5.044 1.062 1.308 4.798.27 3.76 4.007.026z" }, null, -1),
    _createElementVNode("path", { d: "M3.161 1.604h1.683v6.375H3.161z" }, null, -1),
    _createElementVNode("path", { d: "m4 .02 3.737 3.736-1.035 1.036-3.737-3.735z" }, null, -1)
  ]))]))
}
export default { render };